import { render } from "./ShareholderInformation.vue?vue&type=template&id=67a7505c&scoped=true"
import script from "./ShareholderInformation.vue?vue&type=script&lang=js"
export * from "./ShareholderInformation.vue?vue&type=script&lang=js"

import "./ShareholderInformation.vue?vue&type=style&index=0&id=67a7505c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a7505c"]])

export default __exports__